// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'
import Map from 'church-theme-library/components/Map/Map'
import MapMarker from 'church-theme-library/components/Map/MapMarker'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'

class MapSection extends React.Component {

	render() {
		const { contentId, sectionId, data, translate } = this.props
		let mapCenter

		if ( data.map && data.map.lat_lng ) {
			mapCenter = {
				lat: parseFloat( data.map.lat_lng.lat ),
				lng: parseFloat( data.map.lat_lng.lng )
			}
		} else if ( data.map && data.map.lat && data.map.lng ) {
			mapCenter = {
				lat: parseFloat( data.map.lat ),
				lng: parseFloat( data.map.lng )
			}
		} else if ( siteData.location_lat && siteData.location_lng ) {
			mapCenter = {
				lat: parseFloat( siteData.location_lat ),
				lng: parseFloat( siteData.location_lng )
			}
		}

		return (
			<div className="section-map">
				<div className="-inner">
					<div className="-content">
						<Editable
							element="div"
							className="-map"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="map"
						>
							{ mapCenter &&
								<Map
									key={ `${mapCenter.lat}${mapCenter.lng}` }
									defaultCenter={ mapCenter }
									lat={ mapCenter.lat }
									lng={ mapCenter.lng }
								/>
							||
								<div className="map">
									<div className="map-canvas">
										<div className="editor-map-placeholder"></div>
									</div>
								</div>
							}

							<div className="-location">
								<Editable
									element="p"
									id={ contentId }
									sectionId={ sectionId }
									sectionType={ data.type }
									sectionDataId="address"
									content={ data.address }
								/>
							</div>
						</Editable>
					</div>
				</div>
			</div>
		)
	}
}

export default localize( MapSection )
